




import { Component, Vue, Mixins, Watch } from 'vue-property-decorator'
import mixin from './mixin'

@Component({
	name: 'CommonAiiTaskDetail',
})
export default class CommonAiiTaskDetail extends Mixins(mixin) {}
